const Header = () => {
	return (
		<header className='w-full h-12 md:h-16 flex items-center justify-between'>
			<div className='w-12 h-12 md:w-16 md:h-16 bg-logo bg-center bg-cover' />
			<div className='w-44 h-44 md:w-228 md:h-14 bg-black hover:bg-galactic_blue hover:cursor-pointer flex items-center justify-center rounded-full'>
				<p className='font-bold text-14 md:text-16 leading-28 text-light_cream'>
					Free Consultation
				</p>
			</div>
		</header>
	);
};

export default Header;
